const initialState = {
  vehicleWiseCollection: [],
  dayWiseCollection: [],
  collectionSummary: {
    totalCollection: 0,
    totalCardCollection: 0,
    expense: 0,
    finalProfit: 0,
    operatorPayout: 0,
    balanceLoaded: 0,
    walletUsage: 0,
    netDueAmount: 0,
  },
  grossContributionUploadSheetError: "",
};
export default initialState;
